export default "__VITE_ASSET__CNLdTbni__"